<script setup lang="ts">
import {NotificationTemplate as INotificationTemplate} from "@/notification-template/interfaces";
import usePlaceHolders from "@/notification-template/composables/usePlaceHolders";
import CommunicationMessageAuthoring from "@/communication/components/CommunicationMessageAuthoring.vue";
import NotificationTemplate from "@/notification-template/components/NotificationTemplate.vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";

defineProps<{
    templates: INotificationTemplate[];
    loading: boolean;
}>();

defineEmits<{
    (e: 'templateSelected', template: INotificationTemplate);
    (e: 'customContent', content: { content: string, cost: number });
}>();

const {data: placeholders, isLoading: placeholdersLoading} = usePlaceHolders();
</script>

<template>
  <div class="space-y-4">
    <div class="bg-violet-100 p-4 rounded-t-lg">
      <h1 class="text-gray-900">
        Envoyez votre SMS personnalisé
      </h1>
      <CommunicationMessageAuthoring
        :placeholders="placeholders ?? {}"
        @selected="(content, cost) => $emit('customContent', {content, cost})"
      />
    </div>
    <BaseFlexSpinner v-if="loading || placeholdersLoading" />
    <div v-else-if="templates?.length" class="space-y-4">
      <h1 class="text-gray-900">
        Ou choisissez un modèle
      </h1>
      <NotificationTemplate
        v-for="template in templates"
        :key="template.id"
        :template="template"
        selectable
        @selected="$emit('templateSelected', template)"
      />
    </div>
    <div v-else>
      <p>Aucun message disponible.</p>
    </div>
  </div>
</template>

<style scoped>

</style>
